export default __webpack_public_path__ + "static/media/logo.1c09f2ed.png";